import { useState } from 'react';
import { FormCard } from '@portal_components/components/FormCard';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { FormTabHeadings } from '@portal_components/components/FormTabHeadings';
import { Group } from '../../types';
import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from '@portal_components/components/FormCheckbox';

interface InvoiceDetailsProps {
  index: number;
  readonly: boolean;
}

enum EInvoiceDetailsTab {
  CONTACT = 'Invoice Contact',
  ADDRESS = 'Invoice Address'
}

export const InvoiceDetails = ({ index, readonly }: InvoiceDetailsProps) => {
  const { watch } = useFormContext<Group>();
  const [currentTab, setCurrentTab] = useState<EInvoiceDetailsTab>(EInvoiceDetailsTab.CONTACT);

  const [useGroupAddress, usePrimaryContact] = watch([`invoices.${index}.useGroupAddress`, `invoices.${index}.usePrimaryContact`]);

  return (
    <div className="pl-4 pt-4 pb-3 border-l-2 border-secondary-deep-blue-80">
      <div className="w-3/5">
        <FormTextInput<Group> title="Invoice SAP Number" name={`invoices.${index}.sapCustomerNumber`} readonly={readonly} />
      </div>
      <FormTabHeadings<EInvoiceDetailsTab>
        tabs={[EInvoiceDetailsTab.CONTACT, EInvoiceDetailsTab.ADDRESS]}
        currentTab={currentTab}
        handleTabSelected={(tab: EInvoiceDetailsTab) => () => setCurrentTab(tab)}
      />
      {currentTab === EInvoiceDetailsTab.CONTACT && (
        <FormCard columns={2}>
          <div className="flex items-center py-3 pl-2">
            <FormCheckbox<Group> title="Use Group Primary Contact" name={`invoices.${index}.usePrimaryContact`} readonly={readonly} />
          </div>
          <br />
          {!usePrimaryContact && (
            <>
              <FormTextInput<Group> title="Contact Name" name={`invoices.${index}.contact.groupContactName`} readonly={readonly} mandatory />
              <FormTextInput<Group> title="Contact Number" name={`invoices.${index}.contact.groupContactNumber`} readonly={readonly} />
              <FormTextInput<Group> title="Contact Extension" name={`invoices.${index}.contact.extensionNumber`} readonly={readonly} />
              <FormTextInput<Group> title="Contact Email" name={`invoices.${index}.contact.emailAddress`} readonly={readonly} />
              <FormTextInput<Group> title="Contact Job Title" name={`invoices.${index}.contact.jobTitle`} readonly={readonly} />
            </>
          )}
        </FormCard>
      )}
      {currentTab === EInvoiceDetailsTab.ADDRESS && (
        <FormCard columns={2}>
          <div className="flex items-center py-3 pl-2">
            <FormCheckbox<Group> title="Use Group Address" name={`invoices.${index}.useGroupAddress`} readonly={readonly} />
          </div>
          <br />
          {!useGroupAddress && (
            <>
              <FormTextInput<Group> title="Property Name/Number" name={`invoices.${index}.address.addressName`} readonly={readonly} mandatory />
              <FormTextInput<Group> title="Address Line 1" name={`invoices.${index}.address.addressLine1`} readonly={readonly} mandatory />
              <FormTextInput<Group> title="Address Line 2" name={`invoices.${index}.address.addressLine2`} readonly={readonly} />
              <FormTextInput<Group> title="Address Line 3" name={`invoices.${index}.address.addressLine3`} readonly={readonly} />
              <FormTextInput<Group> title="Town" name={`invoices.${index}.address.town`} readonly={readonly} mandatory />
              <FormTextInput<Group> title="County" name={`invoices.${index}.address.county`} readonly={readonly} mandatory />
              <FormTextInput<Group> title="Postcode" name={`invoices.${index}.address.postcode`} readonly={readonly} mandatory />
            </>
          )}
        </FormCard>
      )}
    </div>
  );
};
